import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import styles from "./index.module.css";

import ToggleSwitch from "components/common/ToggleSwitch";

// 하위 페이지 (약관 내용 컴포넌트)
import Privacy from "./contents/Privacy";
import Location from "./contents/Location";
import Service from "./contents/Service";

export default function Terms() {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedIndex, setSelectedIndex] = useState(0);

    // ✅ URL → 토글 상태 동기화
    useEffect(() => {
        if (location.pathname.includes("privacy")) setSelectedIndex(0);
        else if (location.pathname.includes("location")) setSelectedIndex(1);
        else if (location.pathname.includes("service")) setSelectedIndex(2);
        else setSelectedIndex(0); // 기본
    }, [location.pathname]);

    const handleToggle = (value, idx) => {
        setSelectedIndex(idx);
        if (idx === 0) navigate("/term/privacy");
        if (idx === 1) navigate("/term/location");
        if (idx === 2) navigate("/term/service");
    };

    return (
        <div className={styles.container}>
            <ToggleSwitch
                options={["개인 정보 처리 방침", "위치정보 이용 약관", "서비스 이용 약관"]}
                value={selectedIndex}
                onChange={handleToggle}
            />

            <div className={styles.content}>
                <Routes>
                    <Route path="privacy" element={<Privacy />} />
                    <Route path="location" element={<Location />} />
                    <Route path="service" element={<Service />} />
                    {/* 기본 진입 시 개인정보 처리방침 */}
                    <Route path="*" element={<Privacy />} />
                </Routes>
            </div>
        </div>
    );
}
